import { useState } from 'react';
import toast from 'react-hot-toast';

import { useRegisterParticipant } from '../contexts/event';
import { fx } from '../utils/fx';

// Fase 1 — datos del participante. POST register → participant_token (lo guarda
// el orquestador). El primer tap desbloquea el audio (fx.up) para las fases
// siguientes (iOS/Chrome exigen gesto).
export default function Register({ token, onDone }) {
    const reg = useRegisterParticipant(token);
    const [name, setName] = useState('');
    const [cedula, setCedula] = useState('');
    const [email, setEmail] = useState('');

    const submit = (e) => {
        e.preventDefault();
        fx.up();
        if (!name.trim() || !cedula.trim() || reg.isPending) return;
        reg.mutate(
            { name: name.trim(), cedula: cedula.trim(), email: email.trim() || undefined },
            {
                onSuccess: (res) => onDone({ participant_token: res?.participant_token, name: name.trim() }),
                onError: (err) => toast.error(err?.message || 'No pudimos registrarte. Intentá de nuevo.'),
            },
        );
    };

    return (
        <form className="evx__panel evx__reg" onSubmit={submit}>
            <span className="evx__step">Paso 1 de 2</span>
            <h2 className="evx__reg-title">Tus datos para pujar</h2>
            <p className="evx__reg-sub">Reservamos tu cupo en la subasta en segundos.</p>

            <label className="evx__field">
                <span className="evx__label">Nombre</span>
                <input className="evx__input" value={name} onChange={(e) => setName(e.target.value)}
                    maxLength={160} disabled={reg.isPending} autoFocus placeholder="Tu nombre" />
            </label>
            <label className="evx__field">
                <span className="evx__label">Cédula</span>
                <input className="evx__input" value={cedula} onChange={(e) => setCedula(e.target.value)}
                    maxLength={40} inputMode="numeric" disabled={reg.isPending} placeholder="Nº de documento" />
            </label>
            <label className="evx__field">
                <span className="evx__label">Correo <span className="evx__opt">(opcional)</span></span>
                <input className="evx__input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                    disabled={reg.isPending} placeholder="tucorreo@ejemplo.com" />
            </label>

            <button type="submit" className="evx__cta" disabled={reg.isPending || !name.trim() || !cedula.trim()}>
                {reg.isPending ? 'Registrando…' : 'Continuar'}
            </button>
        </form>
    );
}
